import React, { Component } from 'react'
import { Collapse } from 'reactstrap';
import Select from 'react-select';
import Firebase from 'firebase';

const conditions = [
    {
        value: "eq", label: "Igual que"
    },
    {
        value: "neq", label: "Distinto que"
    },
    {
        value: "gt", label: "Mayor que"
    },
    {
        value: "gte", label: "Mayor o igual que"
    },
    {
        value: "lt", label: "Menor que"
    },
    {
        value: "lte", label: "Menor o igual que"
    },
    {
        value: "ct", label: "Que contiene"
    }
]

export default class detailFunction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataset2: "",
            col: this.props.col,
            type: this.props.tipo,
            value: this.props.value,
            condition: this.props.condition
        }
        this.renderColumna = this.renderColumna.bind(this);
        this.renderType = this.renderType.bind(this);
        this.renderValue = this.renderValue.bind(this);
        this.setColumnas2 = this.setColumnas2.bind(this);
        this.renderCondition = this.renderCondition.bind(this);
    }

    componentWillMount() {
        if (this.props.element.element_id === "STORE") {
            var storeRef = Firebase.database().ref('stores')
                .child(localStorage.client_id);
            storeRef.once('value')
                .then(resp => {
                    this.setState({ columnas: Object.keys(resp.val()[0]) });
                })
        } else {
            var datasetsRef = Firebase.database()
                .ref('datasets')
                .child(localStorage.client_id)
                .child("tablas").child(this.props.element.table.dataset);
            datasetsRef.once('value')
                .then(resp => {
                    this.setState({ columnas: Object.keys(resp.val())[0] !== "modified_at" ? Object.values(resp.val())[0] : Object.values(resp.val())[1] })
                })
        }
        Object.values(this.props.data).map((f) => {
            Object.values(f.elements).map((m, index) => {
                if (m.id === this.props.tipo && m.element_id === "DROPDOWNLIST") {
                    this.setColumnas2(m.table.dataset);
                }
            })
        });
    }

    setColumnas(datasetID) {
        var datasetsRef = Firebase.database()
            .ref('datasets')
            .child(localStorage.client_id)
            .child("tablas").child(datasetID);
        datasetsRef.once('value')
            .then(resp => {
                this.setState({ columnas: Object.keys(resp.val())[0] !== "modified_at" ? Object.values(resp.val())[0] : Object.values(resp.val())[1] })
            })
    }

    setColumnas2(datasetID) {
        var datasetsRef = Firebase.database()
            .ref('datasets')
            .child(localStorage.client_id)
            .child("tablas").child(datasetID);
        datasetsRef.once('value')
            .then(resp => {
                this.setState({ columnas2: Object.keys(resp.val())[0] !== "modified_at" ? Object.values(resp.val())[0] : Object.values(resp.val())[1] })
            })
    }

    renderColumna() {
        if (this.state.columnas) {
            var options = [];
            Object.values(this.state.columnas).map((c) => {
                var tt = c;
                tt = tt.substring(tt.indexOf("_") + 1);
                var value = {
                    label: tt,
                    value: c
                }
                options.push(value);
            })
            return (
                <div className="form-group">
                    <label htmlFor="name" style={{ color: "#20a8d8" }}>Columna:</label>
                    <Select
                        name="form-field-name"
                        className="Select Select--single is-clearable is-searchable has-value"
                        value={this.state.col}
                        options={options}
                        onChange={(e) => {
                            this.setState({ col: e.value });
                            this.props.updateFilter(this.state.col, this.state.type, e.value, this.state.condition)
                        }}
                    />
                </div>
            )
        }
    }
    
    renderType() {
        var options = [];
        if (this.state.type) {
            Object.values(this.props.data).map((f) => {
                Object.values(f.elements).map((m, index) => {
                    var tt = m;
                    var value = {
                        label: m.id,
                        value: m.id,
                        dataset: m.table,
                        type: m.element_id
                    }
                    options.push(value);
                })
            });
            var value = {
                label: "valor fijo",
                value: "value",
                type: "value"
            }
            options.push(value)
            return (
                <div className="form-group">
                    <label htmlFor="name" style={{ color: "#20a8d8" }}>Elemento:</label>
                    <Select
                        name="form-field-name"
                        className="Select Select--single is-clearable is-searchable has-value"
                        value={this.state.type}
                        options={options}
                        onChange={(e) => {
                            this.setState({ type: e.value, option: e.type });
                            if (e.type === "DROPDOWNLIST") {
                                this.setColumnas2(e.dataset.dataset);
                            }
                            if (e.type === "value") {
                                this.setState({ value: "" })
                            }
                            else {
                                this.props.updateFilter(this.state.col, e.value, true, this.state.condition)
                            }
                        }}
                    />
                </div>
            )
        }
    }

    renderValue() {
        var options = [];
        if (this.state.columnas2) {
            Object.values(this.state.columnas2).map((c) => {
                var tt = c;
                tt = tt.substring(tt.indexOf("_") + 1);
                var value = {
                    label: tt,
                    value: c
                }
                options.push(value);
            })
        }
        switch (this.state.option) {
            case "DROPDOWNLIST":
                return (
                    <div className="form-group">
                        <label htmlFor="name" style={{ color: "#20a8d8" }}>Valor:</label>
                        <Select
                            name="form-field-name"
                            className="Select Select--single is-clearable is-searchable has-value"
                            value={this.state.value}
                            options={options}
                            onChange={(e) => {
                                this.setState({ value: e.value });
                                this.props.updateFilter(this.state.col, this.state.type, e.value, this.state.condition)
                            }}
                        />
                    </div>
                )

            case "value":
                return (
                    <div className="form-group">
                        <label htmlFor="name" style={{ color: "#20a8d8" }}>Valor:</label>
                        <input type="text" className="form-control-parametros" id="name" value={this.state.value}
                            onChange={(e) => {
                                this.setState({ value: e.target.value })
                                this.props.updateFilter(this.state.col, this.state.type, e.target.value, this.state.condition)
                            }} />
                    </div>
                )
            default:
                return (
                    <div className="form-group">
                        <label htmlFor="name" style={{ color: "#20a8d8" }}>Valor:</label>
                        <input type="text" className="form-control-parametros" id="name" value={"Valor de : " + this.state.type} readOnly />
                    </div>
                )
        }
    }

    renderCondition() {
        return (
            <div className="form-group">
                <label htmlFor="name" style={{ color: "#20a8d8" }}>Condición:</label>
                <Select
                    name="form-field-name"
                    className="Select Select--single is-clearable is-searchable has-value"
                    value={this.state.condition}
                    options={conditions}
                    onChange={(e) => {
                        this.setState({ condition: e.value });
                        this.props.updateFilter(this.state.col, this.state.type, this.state.value, e.value)
                    }}
                />
            </div>
        )
    }

    render() {
        return (
            <div>
                <div className="form-group">
                    {
                        this.renderColumna()
                    }
                </div>
                <div className="form-group">
                    {
                        this.renderCondition()
                    }
                </div>
                <div className="form-group">
                    {
                        this.renderType()
                    }
                </div>
                <div className="form-group">
                    {
                        this.state.option ?
                            this.renderValue()
                            :
                            ""
                    }
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/forms/detailFunction.js